module.exports = __webpack_public_path__ + "img/national-market-icon.405f351e.svg";